import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { onIdTokenChanged, signOut as fbSignOut } from "firebase/auth";
import { auth } from "@/lib/firebase";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [state, setState] = useState({ isLoaded: false, user: null });
  useEffect(() => onIdTokenChanged(auth, (user) => setState({ isLoaded: true, user })), []);
  const getToken = useCallback(async () => (auth.currentUser ? auth.currentUser.getIdToken() : null), []);
  const signOut = useCallback(async ({ redirectUrl } = {}) => {
    await fbSignOut(auth);
    if (redirectUrl) window.location.assign(redirectUrl);
  }, []);
  const needsEmailVerify = !!state.user && !state.user.emailVerified && !state.user.phoneNumber
    && state.user.providerData.some((p) => p.providerId === "password");
  const value = { isLoaded: state.isLoaded, isSignedIn: !!state.user, user: state.user, getToken, signOut, needsEmailVerify };
  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
